import React, { useEffect, useState } from 'react';
import BannerContent from "./BannerContent";
import { getCookie, setCookie } from "./helpers";
import "assets/css/install-banner.css";

const InstallBanner = () => {
  const [show, setShow] = useState(false);
  const [platform, setPlatform] = useState(null);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  const handleCancel = () => {
    setCookie('installBannerDismissed', 'true', 3);
    setShow(false);
  };

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.finally(() => {
        setDeferredPrompt(null);
        setShow(false);
      });
    }
  };

  useEffect(() => {
    if (getCookie('installBannerDismissed')) return;

    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iphone|ipad|ipod/i.test(ua);
    const isAndroid = /android/i.test(ua);
    const isHuawei = /huawei|honor/i.test(ua);

    if (isIOS) {
      setPlatform("ios");
      setShow(true);
    } else if (isHuawei) {
      setPlatform("huawei");
      setShow(true);
    } else if (isAndroid) {
      const handlePrompt = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        setPlatform("androidPrompt");
        setShow(true);
      };

      window.addEventListener('beforeinstallprompt', handlePrompt);

      setTimeout(() => {
        if (!deferredPrompt) {
          setPlatform("androidFallback");
          setShow(true);
        }
      }, 2000);

      return () => window.removeEventListener('beforeinstallprompt', handlePrompt);
    }
  }, [deferredPrompt]);

  return (
    <div id="installBanner" className={show ? 'show' : ''}>
      <BannerContent
        platform={platform}
        onCancel={handleCancel}
        onInstallClick={handleInstallClick}
      />
    </div>
  );
};

export default InstallBanner;
